import { clsx } from "clsx";
import type { ReactNode } from "react";
import { forwardRef } from "react";

import style from "@/modules/core/styles/Tile.module.scss";

interface NoteTileProps {
  children?: ReactNode; // temporary as there is a known bug in the @types definitions with forwardRef
  title: ReactNode;
  footNote?: string;
}

/**
 * !Specific Usage: Only to show information without link.
 * Prefer to use usual CardRowSimple before using this tile.
 */
const NoteTile = forwardRef<HTMLDivElement, NoteTileProps>(function NoteTile(props, ref) {
  return (
    <div className={clsx(style.tile, style.tile_note)} ref={ref}>
      <div className={style.tile_content}>
        <div className={style.title}>{props.title}</div>
        <div>{props.children}</div>
        {props.footNote && <div className={style.description}>{props.footNote}</div>}
      </div>
    </div>
  );
});

export { NoteTile };
